/** Classify axios/API errors for reports config load/save feedback. */

export function getReportsSaveErrorMessage(error) {
  const status = error?.response?.status;
  if (status === 403) {
    return 'شما دسترسی لازم برای ذخیره این گزارش را ندارید.';
  }
  if (error?.code === 'ERR_NETWORK' || !error?.response) {
    return 'ارتباط با سرور برقرار نشد. لطفاً اتصال خود را بررسی کرده و دوباره تلاش کنید.';
  }
  return 'ذخیره گزارش با خطا مواجه شد. لطفاً دوباره تلاش کنید.';
}

export function getReportsLoadErrorMessage(error) {
  const status = error?.response?.status;
  if (status === 403) {
    return 'شما دسترسی لازم برای دریافت تنظیمات گزارش را ندارید.';
  }
  if (error?.code === 'ERR_NETWORK' || !error?.response) {
    return 'ارتباط با سرور برقرار نشد. لطفاً اتصال خود را بررسی کرده و دوباره تلاش کنید.';
  }
  return 'دریافت تنظیمات گزارش با خطا مواجه شد. لطفاً دوباره تلاش کنید.';
}
